module.exports = __webpack_public_path__ + "static/media/event-services-img38.84db7ec4.jpg";